(function () {
  'use strict';

  document.querySelectorAll('.collection-fabric-list').forEach(function (section) {
    var slider = section.querySelector('n-responsive-slider');
    var prevBtn = section.querySelector('.collection-fabric-list__nav-btn--prev');
    var nextBtn = section.querySelector('.collection-fabric-list__nav-btn--next');

    if (!slider || !prevBtn || !nextBtn) return;

    function getBlaze() {
      var blazeEl = slider.querySelector('.blaze-slider');
      return blazeEl ? blazeEl.blazeSlider : null;
    }

    prevBtn.addEventListener('click', function () {
      var instance = getBlaze();
      if (instance) instance.prev();
    });

    nextBtn.addEventListener('click', function () {
      var instance = getBlaze();
      if (instance) instance.next();
    });
  });
})();
